import { useCallback, useMemo } from 'react'
import { getArrayOfSpecificKey } from '../../../utils/tools'

const useReportGroupBar = (graphs) => {
    const sortByDates = useCallback((dates) => dates.sort((a,b) => new Date(a) - new Date(b))
    ,[])

    const barGroupFormatGraphs = useMemo(() => {
        let dates = Array.from(new Set(graphs?.flatMap(data => getArrayOfSpecificKey(data.data, 'date'))))
        dates = sortByDates(dates)
        return dates.filter(date => date).map(date => {
            const newFormat = graphs.map(graph => {
                const tickerValue = graph?.data?.find(data => data.date === date)?.value
                return tickerValue && {[graph.ticker]: tickerValue}
            })
            return {date, ...Object.assign({}, ...newFormat)}
        })
    },[graphs, sortByDates])

    const keys = useMemo(() => {
        return graphs.filter(graph => graph?.data?.length).map(({ticker}) => ticker)
    },[graphs])

    return {
        barGroupFormatGraphs,
        keys
    }
}

export default useReportGroupBar